import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const NetworkLogo = styled.img`
    width: 40px;
`;

export const RowContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: row;
    padding: 6px 12px;
`;

export const NetworkSubtextContainer = styled.div`
    ${BaseStyle.Mixins.gaps.tiny}
    max-width: 232px;
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: 466px;
    }
`;

export const NetworkNames = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body2}
`;

export const Subtext = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    color: ${({ theme }) => theme.Text.secondary};
`;
